<div data-cy="button-toggle-filter-label" class="button-toggle-filter__title search-filter-title">{{
  criteria.label
}}</div>
<mat-button-toggle-group
  class="button-toggle-filter-component__button-group"
  [multiple]="multiple"
  [formControl]="toggleControl"
  >
  @for (option of options; track option) {
    <mat-button-toggle
      [value]="option.value"
      [matTooltip]="option.tooltip"
      [disabled]="(option.value.prediction === 0 && !option.value.selected) || disabled"
      class="button-toggle-filter-component__button"
      [class.button-toggle-filter-component__button--disabled]="option.value.prediction === 0 && option.value.selected"
      data-cy="button-toggle-filter-value"
      >
      @if (criteria.displayProperty === 'isDiabolo') {
        <campus-diabolo-phase
          [diaboloPhaseIds]="option.viewValue"
          [attr.data-cy]="'toggle-diabolo-phase-' + option.viewValue"
          >
        </campus-diabolo-phase>
      } @else {
        @if (criteria.displayProperty === 'label') {
          <span class="ui-caption">
            {{ option.viewValue }}
          </span>
        } @else {
          <campus-icon [svgIcon]="option.viewValue"></campus-icon>
        }
      }
    </mat-button-toggle>
  }
</mat-button-toggle-group>
